<script>
/**
 * 
 * Type         : Page component
 * Title        : 어드민 - 콘솔 관리
 * Description  : 콘솔관리를 위한 페이지 컴포넌트
 * 
 */

import Title from "@/components/admin/common/TitleArea.vue"
import ConsolLookupForm from "@/components/admin/logis/ConsolLookupForm.vue"
import ConsolList from "@/components/admin/logis/list/ConsolList.vue"
import RegiConsolForm from "@/components/admin/logis/modal/RegiConsolForm.vue"

export default {
  name: "Admin-console-management",
  meta: {
    title: "어드민-콘솔"
  },
  components: {
    Title,
    ConsolList,
    RegiConsolForm,
    ConsolLookupForm
  },
  data() {
    return {
      description   : {
        title : '콘솔관리'
      },
      modalConsol : false,
      consolList  : [],
      mblNo       : "", // mblNo
      freightCode : "", // 운항편명
      statusCode  : [], // 오더 상태 코드 목록
      loading     : false,

      selectedCalendarTarget : 'etd', // 선택된 캘린더 타겟
      proxyDate   : {}, // 검색기간
    }
  },
  computed: {
    summary() {
      return this.consolList.reduce((acc, row) => {
        acc.total += 1
        acc.orders += Number(row.totalOrderQty || 0)
        acc.weight += Number(row.totalWeight || 0)
        if (String(row.status) === '001') acc.ready += 1
        return acc
      }, { total: 0, ready: 0, orders: 0, weight: 0 })
    }
  },
  methods:{

    /**
     * Title        : 검색 조건에 따른 콘솔검색을 실행
     * Status       : Actived
     * Description  : 검색 조건에 따른 콘솔검색 기능 실행
     */
    lookupConsol(){
      this.$log.debug("[ 콘솔검색 / lookupConsol ] 검색조건에 따른 콘솔검색 실행")
      this.loadConsolList()
    },


    /**
     * Title        : 검색영역 동기화
     * Status       : Actived
     * Description  : ParcelLookupForm 컴포넌트 - 검색영역에서 받은 검색조건을 동기화한다.
     * Param (idx)  : 선택된 배송상품의 idx
     */
    lookupOptSync(opt){
      this.$log.debug("[ Consol info / 검색조건 ]= " , opt)
      this.mblNo            = opt.mblNo
      this.freightCode      = opt.freightCode
      this.statusCode       = opt.statusCode
      this.proxyDate        = opt.proxyDate
      this.selectedCalendarTarget = opt.selectedCalendarTarget
    },

    /**
     * Title        : 콘솔조회 실행
     * Status       : Actived
     * Description  : 기본 콘솔 조회
     */
    async loadConsolList() {
      this.loading = true
      let payload = {
        mblNo           : this.mblNo,       // mblNo
        freightCode     : this.freightCode, // 운항편명
        status          : this.statusCode,  // 오더 상태 코드 목록
      }
      payload[this.selectedCalendarTarget] = this.proxyDate // 선택된 캘린더 타겟에 따라 검색기간 설정

      // this.$log.debug("payload = ", payload)

      let config = {
        method  : "POST",
        url     : "/api/consol/getConsolList",
        data    : payload,
        name    : "[ Axios / 콘솔목록조회 ]"
      }

      try {
        const res = await this.$http(config)
        const result = Array.isArray(res.data) ? res.data : []
        this.consolList = result.map(row => ({
          ...row,
          expanded: false
        }))
      } catch (error) {
        this.$log.debug("/consol/getConsolList 실패", error)
        this.consolList = []
        this.$q.notify({ type: 'negative', message: '콘솔 목록 조회에 실패했습니다.', position: 'top' })
      } finally {
        this.loading = false
      }
    },

    init() {
      this.loadConsolList()
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<template>

  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        
        <Title
          :desc="description">
          <q-btn-group>
            <q-btn
              flat
              color="grey-7"
              icon="refresh"
              aria-label="새로고침"
              :loading="loading"
              @click="loadConsolList">
              <q-tooltip>새로고침</q-tooltip>
            </q-btn>
            <q-btn
              color="primary"
              size="md"
              icon="add"
              label="신규 콘솔"
              @click="() => { modalConsol = true }"/>
          </q-btn-group>
        </Title>  

      </div>
    </div>

    <div class="row q-col-gutter-md q-mb-lg items-stretch">
      <div class="col-3">
        <div class="comp-box summary-card">
          <div class="text-caption text-grey-7">조회 콘솔</div>
          <div class="text-h5 text-weight-bold q-mt-xs">{{ summary.total }}</div>
        </div>
      </div>
      <div class="col-3">
        <div class="comp-box summary-card">
          <div class="text-caption text-grey-7">출항 대기</div>
          <div class="text-h5 text-weight-bold q-mt-xs">{{ summary.ready }}</div>
        </div>
      </div>
      <div class="col-3">
        <div class="comp-box summary-card">
          <div class="text-caption text-grey-7">포함 오더</div>
          <div class="text-h5 text-weight-bold q-mt-xs">{{ summary.orders }}</div>
        </div>
      </div>
      <div class="col-3">
        <div class="comp-box summary-card">
          <div class="text-caption text-grey-7">상품 중량 합계</div>
          <div class="text-h5 text-weight-bold q-mt-xs">{{ summary.weight.toFixed(2) }} kg</div>
        </div>
      </div>
    </div>

    <div class="row q-mb-lg">
      <div class="col-12 col-md-12 col-lg-10 q-mb-md">
        <div class="comp-box">
          
          <ConsolLookupForm
            @lookup-opt-sync="lookupOptSync" />

        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-2 q-mb-md">
        <q-btn
          color="primary"
          size="lg"
          label="콘솔상품검색"
          class="full-width"
          style="height:100%"
          @click="lookupConsol"/>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="comp-box q-pa-none-important">

          <ConsolList
            :consol-list="consolList"
            :loading="loading"
            @load-consol-list=loadConsolList />
        
        </div>
      </div>
    </div>
  </q-page>

  <Teleport to="body">
    <q-dialog
      v-model="modalConsol"
      transition-show="slide-up"
      transition-hide="slide-down" >

      <RegiConsolForm 
        :mode="'add'"
        :title="'신규콘솔 추가'"
        @refresh-list="loadConsolList"
        @close-modal="modalConsol = false"  
      />
    </q-dialog>
  </Teleport>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.q-pa-none-important {
  padding: 0;
}

.summary-card {
  height: 100%;
}
</style>
